import { useQuery } from "@tanstack/react-query";
import { researchService } from "../services/research.service";

export const useResearchChats = (documentId?: string) => {
  return useQuery({
    queryKey: ["chats", documentId],
    queryFn: () => researchService.getChats(documentId),
    enabled: !!documentId, // Only fetch when documentId is available
  });
};
